import React from 'react';
import ChevronRightSVG from '~/assets/svgs/chevron-right.svg';
import colors from '~/assets/themes/colors';

const Chevron = () => {
  return <ChevronRightSVG color={colors.gray[400]} />;
};

export default Chevron;
